import React from "react";

const Footer = () => {
  return (
    <footer class="bg-gray-900 rounded-lg shadow m-4">
      <div class="w-full mx-auto max-w-screen-xl p-4 md:flex md:items-center justify-center">
        <span class="text-sm text-gray-500 sm:text-center dark:text-gray-400">
          © 2025 Carlos F. Zapata. All Rights Reserved.
        </span>
      </div>
    </footer>
  );
};

export default Footer;



// WEBPACK FOOTER //
// ./src/components/Footer.js